<template lang="html">
    <div class="collection-edit">
        <div class="preloader" v-if="!collectionStatic"></div>

        <div class="collection-edit__inner" v-else>
            <div class="collection-edit__list ui-sortable">
                <div
                    v-for="(item, illustrationIndex) in collectionStatic.illustrations"
                    v-if="collectionStatic.illustrations"
                    :id="'collection-illustration-'+illustrationIndex"
                    class="collection-edit__item sortable-item ui-sortable-handle ui-draggable"
                    :data-resource-weight="item.collection_weight"
                    data-resource-type="collections-illustration"
                    :data-resource-id="item.id">

                    <div class="collection-edit__item-inner">
                        <div class="collection-edit__item-drag-trigger">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                        <div class="collection-edit__item-img">
                            <img :src="'/'+item.thumb_path" alt="">
                        </div>

                        <div class="collection-edit__item-btns">
                            <input type="file">

                            <img src="" alt="" class="collection-edit__item-hidden-img">

                            <div class="collection-edit__item-btn _purple _desc">Title & description</div>
                            <div class="collection-edit__item-btn _gray _image">Replace Image</div>
                            <div class="collection-edit__item-btn _transparent" @click="deleteImage(item.id)">Delete Image</div>
                        </div>
                    </div>

                    <div class="collection-edit__item-desc" style="display: none;">
                        <div class="set-after">
                            <label>Title</label>
                            <input type="text" class="long-input" v-model="collectionDynamic.illustrations[illustrationIndex].title">
                        </div>
                        <div class="set-after">
                            <label>Description (optional)</label>
                            <textarea cols="30" rows="5" :name="'description-'+item.id" class="long-input wysiwyg-please">{{item.description}}</textarea>
                        </div>

                        <div class="checkboxes-wrap set-after" data-max-inputs="2" v-if="checkboxes.subjects">
                            <h3>Subjects (max - 2)</h3>

                            <label class="checkbox-label" v-for="(checkbox, index) in checkboxes.subjects">
                                <div><input type="checkbox" :value="index" v-model="collectionDynamic.illustrations[illustrationIndex].subjects"> {{checkbox}}</div>
                            </label>
                        </div>

                        <div class="checkboxes-wrap set-after" data-max-inputs="2" v-if="checkboxes.style">
                            <h3>Styles (max - 2)</h3>

                            <label class="checkbox-label" v-for="(checkbox, index) in checkboxes.style">
                                <div><input type="checkbox" :value="index" v-model="collectionDynamic.illustrations[illustrationIndex].styles"> {{checkbox}}</div>
                            </label>
                        </div>

                        <div class="checkboxes-wrap set-after" data-max-inputs="1" v-if="checkboxes.types">
                            <h3>Types (max - 1)</h3>

                            <label class="checkbox-label" v-for="(checkbox, index) in checkboxes.types">
                                <div><input type="checkbox" :value="index" v-model="collectionDynamic.illustrations[illustrationIndex].types"> {{checkbox}}</div>
                            </label>
                        </div>

                        <div class="text-center">
                            <button class="big-purple-button save-btn" @click="saveIllustration(item.id)">Save Illustration<span class="inline-loader" style="display: none;"></span></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="collection-edit__btns">
                <a href="#" class="collection-edit__btn _save" @click.prevent="saveCollection">Save Image Set <span class="inline-loader" style="display: none;"></span></a>
                <a :href="addImageHref" class="collection-edit__btn _add-image">Add further images</a>
            </div>
        </div>
    </div>
</template>

<script>
// Component for editing collection

export default {
  props: ['id', 'addImageHref', 'updateImagesHref', 'deleteImagesHref'],
  data() {
    return {
      checkboxes: {
        subjects: null,
        style: null,
        types: null
      },
      collectionStatic: null,
      collectionDynamic: null
    };
  },
  methods: {
    // Get all information about collection from endpoint and do proper actions on callback
    getCollection: function(id){
      axios.get(`/profile/collection/${this.id}/data`)
        .then((response) => {
          let collection;
          let illustrations = response.data.data.collection.illustrations;
          if(_.uniqBy(illustrations, 'collection_weight').length < illustrations.length){
            for(var i = 0; i < illustrations.length; i++){
              illustrations[i].collection_weight = i;
            }
          }
          illustrations = _.orderBy(illustrations, 'collection_weight');
          for(var i = 0; i < illustrations.length; i++){
            let illustration = illustrations[i];
            for(var j = 0; j < illustration.subjects.length; j++){
              illustration.subjects[j] = illustration.subjects[j].id;
            }
            for(var j = 0; j < illustration.styles.length; j++){
              illustration.styles[j] = illustration.styles[j].id;
            }
            for(var j = 0; j < illustration.types.length; j++){
              illustration.types[j] = illustration.types[j].id;
            }
          }

          collection = response.data.data.collection;
          collection.illustrations = illustrations;
          this.collectionStatic = collection;
          this.collectionDynamic = _.cloneDeep(collection);

          this.checkboxes.subjects = response.data.data.subjects;
          this.checkboxes.style = response.data.data.style;
          this.checkboxes.types = response.data.data.types;

          // Actions which should be performed after DOM will be ready
          setTimeout(() => {
            let self = this;
            $( ".ui-sortable" ).sortable({
              start: function (event, ui) {
                var id_textarea = ui.item.find(".wysiwyg-please").attr("name");
                CKEDITOR.instances[id_textarea].destroy();
              } ,
              stop: function (event, ui) {
                var id_textarea = ui.item.find(".wysiwyg-please").attr("name");
                CKEDITOR.replace(id_textarea);
              },
              update: ( event, ui ) => {
                self.changeOrder();
              }
            });

            $('.wysiwyg-please').each(function (index, element) {
              CKEDITOR.replace(window.$(element).attr('name'), {
                uiColor: '#dddddd'
              });
            });

            $(document).on('change', '.checkboxes-wrap input[type="checkbox"]', function(){
              let $inputsParent = $(this).parents('.checkboxes-wrap');
              if($inputsParent.find('input[type="checkbox"]:checked').length >= $inputsParent.data('max-inputs')){
                $inputsParent.find('input[type="checkbox"]:not(:checked)').prop('disabled', true);
              } else {
                $inputsParent.find('input[type="checkbox"]').prop('disabled', false);
              }
            });

            $('.checkboxes-wrap').each(function(){
              if($(this).find('input[type="checkbox"]:checked').length >= $(this).data('max-inputs')){
                $(this).find('input[type="checkbox"]:not(:checked)').prop('disabled', true);
              } else {
                $(this).find('input[type="checkbox"]').prop('disabled', false);
              }
            });
          }, 100);
        })
        .catch((error) => {
          console.error('Error in collection request', error);
        });
    },
    // Change properties weight in collection
    changeOrder: function(){
      let self = this;
      let increment = 0;
      $('.collection-edit__item').each(function(){
        let index = _.findIndex(self.collectionDynamic.illustrations, (item) => {
          return item.id == $(this).data('resource-id');
        });
        self.collectionDynamic.illustrations[index].collection_weight = increment;
        increment++;
      });
    },
    // Upload new image and perform cropper
    changeImage: function (input) {
      let illustrationId = $(input).parents('.collection-edit__item').data('resource-id');
      let formData = new FormData();
      let image = input.files[0];
      if (!image.type.match('image.*')) {
        return false;
      }
      formData.append('image', image);
      formData.append('need_duplicate', 1);
      axios.post('/ajax/image/upload', formData, {
        headers: { 'content-type': 'multipart/form-data' }
      })
        .then((response) => {
          this.initCrop(response, illustrationId);
        }).catch((error) => {
          console.error('Error in image upload request', error);
        });
    },
    // Initialize cropper and save image in collection at the end
    initCrop(response, illustrationId){
      let vm = this;
      let modalHtml = window.$('#crop-image').clone();
      let cropper = null;
      window.$('#image-to-crop').attr('src', '/' + response.data['original_image']);
      window.$('#crop-image').modal({
        backdrop: 'static'
      });
      window.$('#crop-image').on('shown.bs.modal', function () {
        if (cropper) {
          cropper.destroy();
        }
        let image = document.getElementById('image-to-crop');

        cropper = new Cropper(image, {
          viewMode: 2,
          autoCropArea: 1,
          aspectRatio: 1,
          autoCrop: true,
          restore: false,
          minCanvasWidth: 700,
          crop: function(cropDetails) {
            if (Math.ceil(cropDetails.detail.width) < 700 || Math.ceil(cropDetails.detail.height) < 700) {
              cropper.setData({width: 700, height: 700});
            }
          }
        });
        window.$('.rotate-right').click(function (event) {
          event.preventDefault();
          cropper.rotate(45);
        });
        window.$('.rotate-left').click(function (event) {
          event.preventDefault();
          cropper.rotate(-45);
        });
        window.$('.zoom-in').click(function (event) {
          event.preventDefault();
          cropper.zoom(0.1);
        });
        window.$('.zoom-out').click(function (event) {
          event.preventDefault();
          cropper.zoom(-0.1);
        });
        window.$('.cancel-crop').click(function (event) {
          event.preventDefault();
          cropper.reset();
        });
        window.$('.save-crop').click(function (click) {
          click.preventDefault();
          let cropInfo = cropper.getData(true);
          cropInfo.key = response.data['id'];
          cropInfo.image_extension = response.data['image_extension'];

          // apply crop changes and set
          axios.post('/ajax/image/transform', cropInfo)
            .then(() => {
              $(`.collection-edit__item[data-resource-id="${illustrationId}"] .collection-edit__item-img img`).attr('src', '/'+response.data['image']);
              cropper.destroy();
              window.$('#crop-image').modal('hide');
              let illustrationIndex = _.findIndex(vm.collectionDynamic.illustrations, function(item){
                return item.id == illustrationId;
              });
              vm.collectionDynamic.illustrations[illustrationIndex].newImage = response.data;
            });
        });
      });
      window.$('button.delete-image').click((click) => {
        click.preventDefault();
        cropper.destroy();
        window.$('#crop-image').modal('hide');
      });
      window.$('#crop-image').on('hidden.bs.modal', () => {
        window.$('#crop-image').after(modalHtml).remove();
      });
    },
    // Get all data from checkboxes and CKEditor before saving illustration
    preSaveIllustration: function(illustrationId){
      let illustrationIndex = _.findIndex(this.collectionDynamic.illustrations, function(item){
        return item.id == illustrationId;
      });

      for(var i = 0; i < this.collectionDynamic.illustrations[illustrationIndex].subjects.length; i++){
        this.collectionDynamic.illustrations[illustrationIndex].subjects[i] = _.toInteger(this.collectionDynamic.illustrations[illustrationIndex].subjects[i]);
      }
      for(var i = 0; i < this.collectionDynamic.illustrations[illustrationIndex].styles.length; i++){
        this.collectionDynamic.illustrations[illustrationIndex].styles[i] = _.toInteger(this.collectionDynamic.illustrations[illustrationIndex].styles[i]);
      }
      for(var i = 0; i < this.collectionDynamic.illustrations[illustrationIndex].types.length; i++){
        this.collectionDynamic.illustrations[illustrationIndex].types[i] = _.toInteger(this.collectionDynamic.illustrations[illustrationIndex].types[i]);
      }

      this.collectionDynamic.illustrations[illustrationIndex].description = CKEDITOR.instances['description-'+illustrationId].getData();
    },
    // Request to save illustration
    saveIllustration: function(illustrationId){
      $(`.collection-edit__item[data-resource-id="${illustrationId}"] .save-btn .inline-loader`).show();
      this.preSaveIllustration(illustrationId);
      let illustrationIndex = _.findIndex(this.collectionDynamic.illustrations, function(item){
        return item.id == illustrationId;
      });

      axios.post(this.updateImagesHref, {
        illustrations: [this.collectionDynamic.illustrations[illustrationIndex]]
      })
        .then((response) => {
          $(`.collection-edit__item[data-resource-id="${illustrationId}"] .save-btn .inline-loader`).hide();
        })
        .catch((error) => {
          $(`.collection-edit__item[data-resource-id="${illustrationId}"] .save-btn .inline-loader`).hide();
          console.error('Error in save collection request', error);
        });
    },
    // Request to save all collection
    saveCollection: function(){
      $('.collection-edit__btn._save .inline-loader').show();
      for(var i = 0; i < this.collectionDynamic.illustrations.length; i++){
        this.preSaveIllustration(this.collectionDynamic.illustrations[i].id);
      }

      axios.post(this.updateImagesHref, {
        illustrations: this.collectionDynamic.illustrations
      })
        .then((response) => {
          $('.collection-edit__btn._save .inline-loader').hide();
          location.href = '/profile/portfolio';
        })
        .catch((error) => {
          $('.collection-edit__btn._save .inline-loader').hide();
          console.error('Error in save collection request', error);
        });
    },
    // Delete illustration from collection
    deleteImage: function(id){
      if(confirm('Do you realy want to delete this illustration?')){
        let illustrations_ids = [];
        illustrations_ids.push(id);

        axios.post(this.deleteImagesHref, {
          illustrations_ids: illustrations_ids
        })
          .then((response) => {
            $(`.collection-edit__item[data-resource-id="${id}"]`).remove();
          })
          .catch((error) => {
            console.error('Error in collection image delete request', error);
          });
      }
    },
  },
  mounted() {
    let self = this;

    this.getCollection(this.id);

    // Toggle appearing of description of ullustration
    $(document).on('click', '.collection-edit__item-btn._desc', function(){
      let descEl = $(this).parents('.collection-edit__item').find('.collection-edit__item-desc');
      if(descEl.is(':visible')){
        descEl.slideUp();
      } else {
        descEl.slideDown();
      }
    });
    // Trigger change of image
    $(document).on('click', '.collection-edit__item-btn._image', function(){
      let inputEventsList = $._data($(this).siblings('input[type="file"]')[0], "events");
      if(!inputEventsList || !inputEventsList.hasOwnProperty('change')){
        $(this).siblings('input[type="file"]').on('change', function(){
          self.changeImage(this);
        });
      }
      $(this).siblings('input[type="file"]').click();
    });
  }
};
</script>

<style lang="scss">
    .collection-edit {
        max-width: 800px;
        margin: 0 auto;

        .preloader {
            display: block;
            width: 50px;
            height: 50px;
            margin: 0 auto;
            border-top: 9px solid rgba(0, 0, 0, 0.2);
            border-right: 9px solid rgba(0, 0, 0, 0.2);
            border-bottom: 9px solid rgba(0, 0, 0, 0.2);
            border-left: 9px solid #6E1B56;
            border-radius: 50%;
            animation: load 1.1s infinite linear;
        }
    }

    @keyframes load {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .collection-edit__item {
        padding: 30px 0;
        border-bottom: 2px solid #ccc;
    }

    .collection-edit__item-inner {
        display: table;
        width: 100%;
    }

    .collection-edit__item-drag-trigger {
        display: table-cell;
        width: 50px;
        vertical-align: middle;

        span {
            display: block;
            width: 8px;
            height: 8px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 5px;
            border-radius: 50%;
            background: #555555;

            &:last-of-type { margin-bottom: 0; }
        }
    }
    .collection-edit__item-img {
        display: table-cell;
        width: 100px;
        vertical-align: middle;

        img {
            width: 100%;
        }
    }
    .collection-edit__item-btns {
        display: table-cell;
        width: calc(100% - 180px);
        padding-left: 30px;
        vertical-align: middle;
        font-size: 0;

        input[type="file"] {
            display: none;
        }
    }
    .collection-edit__item-hidden-img {
        display: none;
    }

    .collection-edit__item-btn {
        display: inline-block;
        width: 30%;
        margin-right: 5%;
        padding: 15px 0;
        border: 3px solid;
        border-radius: 5px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        white-space: nowrap;
        cursor: pointer;

        &:last-of-type { margin-right: 0; }

        &._purple {
            border-color: #6f1b57;
            background-color: #6f1b57;
            color: #fff;
        }
        &._gray {
            border-color: #c5c5c5;
            background-color: #c5c5c5;
            color: #555555;
        }
        &._transparent {
            border-color: #555555;
            background-color: transparent;
            color: #555555;
        }
    }

    .collection-edit__btns {
        margin-top: 30px;
    }

    .collection-edit__btn {
        display: block;
        width: 400px;
        max-width: 100%;
        margin: 10px auto;
        padding: 10px 0;
        border-radius: 5px;
        color: #fff;
        text-align: center;

        &._save {
            background-color: #6f1b57;
        }
        &._add-image {
            background-color: #c5c5c5;
        }
    }

    .collection-edit__item-desc {
        margin-top: 30px;
        padding-top: 30px;
        border-top: 2px solid #ccc;

        .save-btn {
            margin-top: 20px;
        }
    }

    .inline-loader {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 3px solid rgba(255,255,255,0.5);
        border-left-color: rgba(255,255,255,0.9);
        animation: loading-bar-spinner 0.6s linear;
        animation-iteration-count: infinite;
    }

    @keyframes loading-bar-spinner {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>